import { Box, BoxProps, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useNavigation } from '@react-navigation/native'
import { useStores } from '../../data/store'

const HoldTransaction = ({ route }) => {
  const { id } = route?.params ?? {}
  localStorage.setItem('params', id)
  if (!id) {
    return null
  }

  const { getTransactionWithId, getTransactionStatus } = useStores((store) => ({
    getTransactionWithId: store.riskConfig.getTransactionWithId,
    getTransactionStatus: store.riskConfig.getTransactionStatus,
  }))

  const data = getTransactionWithId(id)
  const status = getTransactionStatus(id)
  const { navigate } = useNavigation()
  return (
    <Box {...styles.container}>
      <Box flexDirection={'row'} align={'center'} justify={'space-between'}>
        <Text title={'Hold/Release Transaction'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
        <ButtonNew
          title={status.toLowerCase() === 'active' ? 'Hold' : 'Release'}
          onPress={() => navigate('riskconfig')}
        />
      </Box>
      <Spacer direction={'vertical'} size={16} />
      {data.map((item) => (
        <Box flexDirection={'row'} p={16}>
          <Box w={180}>
            <Text fontFamily={'jiotype-medium'} fontSize={14} color={'PRIMARY_GREY'} title={item.title} />
          </Box>
          <Spacer size={8} />
          <Text fontFamily={'jiotype-medium'} fontSize={14} color={'BLACK_21'} title={item.value} textAlign={'left'} />
        </Box>
      ))}
    </Box>
  )
}

const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    p: 20,
    overflow: 'auto',
  } as BoxProps,
}

export default HoldTransaction
